module.exports = __webpack_public_path__ + "img/apertura.3e33d167.svg";